import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesCalculation from './UtilitiesCalculation';
import { ELECTRICITY, UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ElectricityCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      administrativeFeeField={ELECTRICITY.FIELD_NAME.ADMINSTRATIVE_FEE}
      listBoxField={ELECTRICITY.FIELD_NAME.FIXED_AMOUNT_CALCULATION}
      otherMethodDescriptionField={ELECTRICITY.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={ELECTRICITY.FIELD_NAME.OTHER_METHOD}
      options={UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Electricity"
    />
  );
}

ElectricityCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default ElectricityCalculation;
